import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import MasterListReport from './MasterListReport';

function MasterListReportWrapper() {
    const location = useLocation();
    const [showComponent, setShowComponent] = useState(true);

    useEffect(() => {

        console.log("location.search", location.search)
        setShowComponent(false);
        const timeout = setTimeout(() => {
            setShowComponent(true);
        }, 10); // short delay forces unmount/remount

        return () => clearTimeout(timeout);
    }, [location.search]);

    return showComponent ? <MasterListReport /> : <div></div>;
}

export default MasterListReportWrapper;